import { User } from "../models/Person";

/** Industry tags for public profile cards (legacy industries + current_industry). */
export const getProfileIndustryTags = (user: Partial<User> | null | undefined): string[] => {
  if (!user) return [];

  const fromIndustries = normalizeIndustryField(user.industries);
  if (fromIndustries.length > 0) return fromIndustries;

  return normalizeIndustryField(user.current_industry);
};

const normalizeIndustryField = (value: string | string[] | undefined): string[] => {
  if (!value) return [];
  if (Array.isArray(value)) return value.filter(Boolean);
  if (typeof value === "string" && value.includes(";;;")) {
    return value.split(";;;").map((s) => s.trim()).filter(Boolean);
  }
  return value.trim() ? [value.trim()] : [];
};
